import { ChangeEvent, Component, ReactNode } from 'react';
import { BraxTextField, BraxTextFieldProps } from 'design-system';

import masks from '../../variables/masks';
import t from '../../utils/i18n';
import UserAddress from '../../view-model/users/UserAddress';
import usersService from '../../services/users';

export type ZipCodeFieldProps = Omit<BraxTextFieldProps, 'type' | 'mask' | 'label'> & {
    label?: ReactNode
    isForeign: boolean,
    onLoadStart?: () => void,
    onLoaded: (address: Partial<UserAddress>) => void,
    onLoadFail?: (error: Error) => void
};

type ZipCodeFieldState = {
    error: boolean
};

export default class ZipCodeField extends Component<ZipCodeFieldProps, ZipCodeFieldState> {

    state = {
        error: false
    };

    maskApply = false;

    async change(value: string, event: ChangeEvent<HTMLInputElement>) {
        this.props.onChange?.(value, event);

        if (this.maskApply) {
            this.maskApply = false;

            return;
        }

        this.setState({ error: false });

        if (this.props.isForeign || !value || value.match(/^[0-9]{2}\.?[0-9]{3}-?[0-9]{3}$/) === null)
            return;

        this.props.onLoadStart?.();

        try {
            const address = await usersService.getZipCode(value);

            if (address)
                this.props.onLoaded(address);
            else
                this.props.onLoadFail?.(new Error('not found'));
        } catch (error) {
            this.setState({ error: true });

            this.props.onLoadFail?.(error as Error);
        }
    }

    render() {
        const { isForeign, onChange, onLoadStart, onLoaded, onLoadFail, ...props } = this.props;

        return (
            <BraxTextField
                type="text"
                mask={!isForeign ? masks.cep : undefined}
                label={'label' in props ? props.label : t(isForeign ? 'Código postal' : 'CEP')}
                placeholder={'placeholder' in props ? props.placeholder : isForeign ? 'ex. 12345' : 'ex. 12.123-123'}
                hint={this.state.error ? t('Não foi possível carregar CEP') : undefined}
                onChange={(value, event) => this.change(value, event)}
                {...props}
            />
        );
    }

}
